// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SoNDsXnqJrgEEK1BLU_3 {
	display: flex;
	flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/components/FactList.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,eAAe;AAChB","sourcesContent":[".container {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n}"],"sourceRoot":""}]);
// Exports
export var container = `SoNDsXnqJrgEEK1BLU_3`;
export default ___CSS_LOADER_EXPORT___;
